<template>
  <Dropdown placement="top-left">
    <template #trigger>
      <div class="profile">
        <ProfilePicture :firstName=" user?.personal_information?.first_name" :lastName=" user?.personal_information?.last_name" ></ProfilePicture>
        <span>{{ user?.personal_information?.first_name }} {{ user?.personal_information?.last_name }}</span>
      </div>
    </template>
    <template #menu="{ close }">
      <div class="dropdown__menu">
        <div class="dropdown__item" @click="router.push({ name: 'profil' }); close()">
          <i class="bi bi-gear"></i>
          <span>{{ $t('app.sidebar.profile.settings') }}</span>
        </div>
        <div class="dropdown__item" @click="logoutNow">
          <i class="bi bi-box-arrow-left red"></i>
          <span class="red">{{ $t('app.sidebar.profile.logout') }}</span>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import Dropdown from "@/components/global/Dropdown.vue";
import { useUser } from "@/queries/user.query";
import { logout } from "@/queries/user.query";
import ProfilePicture from "./ProfilePicture.vue";

const router = useRouter();
const { data: user } = useUser();

function logoutNow() {
  logout();

  router.push({
    name: "auth",
  });
}
</script>

<style lang="scss" scoped>
.red {
  color: red;
}

.profile {
  display: flex;
  gap: 8px;
  align-items: center;
  user-select: none;

  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;

  &.mobile {
    justify-content: center;
  }

  &:hover {
    background-color: var(--light-grey-color);
  }
}
</style>
